/**
 * @file AttentionProblem.tsx
 * @description Проблема строки «Требуют внимания» — значок и текст в тоне
 * (phase19.31): янтарный — ждёт действия, красный — риск потерять посылку.
 * Цвета — статусов темы, а не зашитые.
 */

import { TriangleAlert } from "lucide-react";

import { ATTENTION_TONE_CLASS, type AttentionRow } from "../../../lib/order-attention-rows";
import { cn } from "@/lib/utils";

export function AttentionProblem({ row }: { row: AttentionRow }) {
  return (
    <span className={cn("inline-flex min-w-0 items-center gap-1.5 font-medium", ATTENTION_TONE_CLASS[row.tone])}>
      <TriangleAlert className="size-4 shrink-0" aria-hidden />
      <span className="truncate">{row.problem}</span>
    </span>
  );
}
